import mainViewMixin from './mainViewMixin';
import { mapState } from 'vuex';
import { themesMixin, vuetifyColors } from '@/utils/themes';
import { downloadAttachment } from '@/utils/vuex';
import { localizeDate } from '@/utils/date';
export default {
  name: 'ViewNiotaClassicDeviceMonitoring',
  mixins: [mainViewMixin, themesMixin],
  data: function () {
    return {
      accountId: this.$store.state.authentication.tenantId,
      filterAlert: false,
      filterWarning: false,
      filterThreshold: false,
      resetFilter: false,
      filteredList: [],
      gwHasNonEmptyList: false,
      gwVisualizationDialog: false,
      gwAlertNotificationDialog: false,
      tabItem: 'devices'
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions']),
    headerBG() {
      return './img/consumer.png';
    },
    hasGWMonitoringPermission() {
      return this.permissions['IotHub.read'] || this.permissions['all.read'];
    }
  },
  watch: {
    tabItem() {
      if (this.tabItem === 'tab-gateways') {
        this.filterWarning = true;
        this.filterAlert = true;
      } else {
        this.filterWarning = false;
        this.filterAlert = false;
        this.filterThreshold = false;
      }
    }
  },
  methods: {
    getColor(type) {
      return vuetifyColors[type] || this.vuetifyColorHex('info');
    },
    getFilteredList(filteredList) {
      this.filteredList = filteredList;
    },
    runCSVExport() {
      let list = this.filteredList;
      if (list.length) {
        const date = new Date();
        let header = this.getHeader();
        let body = this.buildCSVBody(list);
        let data = header + body;
        const fileName = `device_monitoring_${date.toISOString()}.csv`;
        downloadAttachment('text/csv', data, fileName);
      } else {
        this.$snack(this.$i18n_t('NiotaClassic.DeviceMonitoring.notFound'), 'error');
      }
    },
    getStatus(device) {
      let status = null;
      if (device.battery_alert_status) {
        status = `${this.$i18n_t('NiotaClassic.DeviceMonitoring.alert')}: ${this.$i18n_t('NiotaClassic.DeviceMonitoring.alertMsg')}`;
      } else if (!device.battery_alert_status && device.battery_warning_status) {
        status = `${this.$i18n_t('NiotaClassic.DeviceMonitoring.warning')}: ${this.$i18n_t('NiotaClassic.DeviceMonitoring.warningMsg')}`;
      } else if (!device.battery_alert_status && !device.battery_warning_status && device.threshold > device.packetCount) {
        status = `${this.$i18n_t('NiotaClassic.DeviceMonitoring.alert')}: ${this.$i18n_t('NiotaClassic.DeviceMonitoring.thresholdAlertMsg')}`;
      }
      return status;
    },
    getAdditionalInformation(device) {
      let additionalInformation = null;
      if (device.battery_alert_status) {
        additionalInformation = `${this.$i18n_t('NiotaClassic.DeviceMonitoring.battery')}: ${device.battery_value.value.toFixed(2)} - ${this.$i18n_t('NiotaClassic.DeviceMonitoring.alertLevel')}: ${device.variable.alert_level}`;
      } else if (!device.battery_alert_status && device.battery_warning_status) {
        additionalInformation = `${this.$i18n_t('NiotaClassic.DeviceMonitoring.battery')}: ${device.battery_value.value.toFixed(2)} - ${this.$i18n_t('NiotaClassic.DeviceMonitoring.warningLevel')}: ${device.variable.warning_level}`;
      } else if (!device.battery_alert_status && !device.battery_warning_status && device.threshold > device.packetCount) {
        additionalInformation = `${this.$i18n_t('NiotaClassic.DeviceMonitoring.sent')}: ${device.packetCount} - ${this.$i18n_t('NiotaClassic.DeviceMonitoring.threshold')}: ${device.threshold}`;
      }
      return additionalInformation;
    },
    getHeader() {
      let header = `${this.$i18n_t('NiotaClassic.Common.table.id')},${this.$i18n_t('NiotaClassic.Common.table.title')},${this.$i18n_t('NiotaClassic.Common.table.eui')},${this.$i18n_t('NiotaClassic.DeviceMonitoring.status')},${this.$i18n_t('NiotaClassic.DeviceMonitoring.additionalInformation')},${this.$i18n_t('NiotaClassic.DeviceMonitoring.lastPacket')};
        `;
      return header;
    },
    buildCSVBody(list) {
      let body = '';
      list.forEach(device => {
        let row = `${device.id},${device.title},${device.eui},${this.getStatus(device)},${this.getAdditionalInformation(device)},${this.localizeDate(device.lastPacket)};\n
          `;
        body += row;
      });
      return body;
    },
    localizeDate(item) {
      if (item) {
        return localizeDate(item);
      }
    },
    pushMapToRouter() {
      let accountId = this.accountId || this.$store.state.authentication.tenantId;
      this.$router.push(`/niota-classic/gw-mgmt/map/${accountId}/gateways/?monitoring&warning=${this.filterWarning}&alert=${this.filterAlert}`);
    }
  }
};